import request from '@/utils/request';

const PATH = '/service/terms';

export const getServiceTermsList = () => request({
  url: PATH,
  method: 'get',
});
